/* eslint consistent-return: 0 */
/**
 * See schema for all legal values, data will not be transformed.
 */
/**
 * Create a valid Location object according to schema. Will only create the
 * required '@type' field, input will be merged with the object as is.
 */
export default function location(input) {
  var _ref = input || {},
    data = _ref.location;
  if (data) {
    return Object.assign({
      '@type': 'GeoCoordinates'
    }, data);
  }
}
export function defaultValue() {}